import { render, staticRenderFns } from "./FRZChamberPalletChamber.vue?vue&type=template&id=70ae679b"
import script from "./FRZChamberPalletChamber.vue?vue&type=script&lang=js"
export * from "./FRZChamberPalletChamber.vue?vue&type=script&lang=js"
import style0 from "./FRZChamberPalletChamber.vue?vue&type=style&index=0&id=70ae679b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports